import React, { ElementType } from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import BaseInputText from '../InputText';
import OrderBtns from '../OrderBtns';

import { IDispatch } from '../../../../../modules/stores';

import { ISpace } from '../../../../../types/space';
import { PairInputs } from '../styled';

type IConnectProps = ReturnType<typeof mapDispatch>;
interface IProps extends IConnectProps, WrappedComponentProps {
  space: ISpace<ElementType>;
  isAvoidCollision?: boolean;
  isTable?: boolean;
}

const SpaceConfigs = ({
  space,
  updateSpace,
  isAvoidCollision = false,
  isTable = false,
  intl: { formatMessage },
}: IProps) => (
  <>
    <PairInputs>
      <BaseInputText
        name="posX"
        isPair
        setFn={(val: number) => {
          updateSpace({
            id: space.id,
            updates: { posX: Number(val) },
          });
        }}
        title="X"
        type="number"
        value={space.posX}
      />
      <BaseInputText
        name="posY"
        isPair
        setFn={(val: number) => {
          updateSpace({
            id: space.id,
            updates: { posY: Number(val) },
          });
        }}
        title="Y"
        type="number"
        value={space.posY}
      />
    </PairInputs>
    <PairInputs>
      <BaseInputText
        name="height"
        isPair
        setFn={(val: number) => {
          updateSpace({
            id: space.id,
            updates: { height: Number(val) },
          });
        }}
        title={
          isAvoidCollision
            ? formatMessage({ id: 'sidebar.minHeight' })
            : formatMessage({ id: 'sidebar.height' })
        }
        type="number"
        value={space.height}
      />
      <BaseInputText
        name="width"
        isPair
        setFn={(val: number) => {
          updateSpace({
            id: space.id,
            updates: { width: Number(val) },
          });
        }}
        title={formatMessage({ id: 'sidebar.width' })}
        type="number"
        value={space.width}
      />
    </PairInputs>
    {!isTable && (
      <BaseInputText
        name="rotation"
        setFn={(val: number) => {
          updateSpace({
            id: space.id,
            updates: { rotation: Number(val) },
          });
        }}
        title={formatMessage({ id: 'sidebar.rotation' })}
        type="number"
        value={space.rotation}
      />
    )}
    <OrderBtns spaceId={space.id} />
  </>
);

const mapDispatch = ({ space }: IDispatch) => ({
  updateSpace: (payload: any) => space.updateSpace(payload),
});

export default compose(
  injectIntl,
  connect(
    () => ({}),
    // @ts-ignore
    mapDispatch,
  ),
)(SpaceConfigs);
